import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'circle-x', 'CircleX', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}],["path",{"d":"M10 10l4 4m0 -4l-4 4"}]]);